<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<h2 class="contentsHead">CONTENTS</h2>
<p class="contentsEntry"><a href="#/LuftwaffeFighterPilot_preface#preface">Preface</a></p>
<p class="contentsEntry"><a href="#/LuftwaffeFighterPilot_ch1#chapter1">Chapter 1: A Carefree Childhood</a></p>
<p class="contentsEntry"><a href="#/LuftwaffeFighterPilot_ch2#chapter2">Chapter 2: Growing up in the ‘New Age’</a></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch3#chapter3" title="Link target outside of Sample">Chapter 3: War is Declared</span></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch4#chapter4" title="Link target outside of Sample">Chapter 4: The Start of my Flying Career</span></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch5#chapter5" title="Link target outside of Sample">Chapter 5: Training to be a Fighter Pilot</span></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch6#chapter6" title="Link target outside of Sample">Chapter 6: Posted to the Front</span></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch7#chapter7" title="Link target outside of Sample">Chapter 7: The Normandy Invasion</span></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch8#chapter8" title="Link target outside of Sample">Chapter 8: Captivity</span></p>
<p class="contentsEntry"><span href="#/LuftwaffeFighterPilot_ch9#chapter9" title="Link target outside of Sample">Chapter 9: The War is Over</span></p>
<p class="contentsEntry">Appendices</p>
<p class="contentsEntry1"><span href="#/LuftwaffeFighterPilot_appendix1#appendix1" title="Link target outside of Sample">Aircraft Types Flown by the Author</span></p>
<p class="contentsEntry1"><span href="#/LuftwaffeFighterPilot_appendix2#appendix2" title="Link target outside of Sample">Units in which the Author Served</span></p>
<p class="contentsEntry1"><span href="#/LuftwaffeFighterPilot_appendix3#appendix3" title="Link target outside of Sample">Unit Notes and Histories</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LuftwaffeFighterPilot_toc.vue?5922b2b1